import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RowDetalheItemGuia } from '../../detalhes-guia.component';

@Component({
    selector: 'bl-guia-item-group-cell',
    templateUrl: './item-group-cell.component.html',
    styleUrls: ['./item-group-cell.component.scss'],
    standalone: false
})
export class ItemGroupCellRenderer implements ICellRendererAngularComp {
  params: ICellRendererParams<RowDetalheItemGuia>;
  data: RowDetalheItemGuia;
  displayValue: string;
  empty: boolean;

  constructor() {}

  agInit(params: ICellRendererParams<RowDetalheItemGuia>): void {
    this.updateValue(params);
  }

  refresh(params: ICellRendererParams<RowDetalheItemGuia>) {
    this.updateValue(params);
    return true;
  }

  updateValue(params: ICellRendererParams<RowDetalheItemGuia>) {
    this.params = params;
    this.data = params.data;
    this.displayValue = params.valueFormatted ?? params.value;
    this.empty = true;
    if (
      params.data?.row_criticas_item?.length ||
      params.data?.row_detalhe_pacote?.length ||
      params.data?.row_motivos_rejeicao?.length
    ) {
      this.empty = false;
    }
  }
}
